import AboutUs from './about-us.vue'

export default AboutUs
